import useAuth from 'hooks/useAuth';
import { GroupGuardProps } from 'types/auth';
import { BO_ADMIN, isUserInAllowedGroup } from './roles-check';
import { Navigate, useLocation } from 'react-router';

const GroupGuard = ({ allowedGroups, children }: GroupGuardProps) => {
    const { user } = useAuth();
    const location = useLocation();

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} />;
    }

    const isAdmin = user.roles.includes(BO_ADMIN);
    const userInAllowedGroup = isUserInAllowedGroup(user.groups, allowedGroups);

    if (!isAdmin && !userInAllowedGroup) {
        return <Navigate to="/unauthorized" state={{ from: location }} />;
    }

    return children;
};

export default GroupGuard;
